import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=5653b73c&scoped=true"
import script from "./BillingSettings.vue?vue&type=script&lang=js"
export * from "./BillingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653b73c",
  null
  
)

export default component.exports